import React, { memo, useCallback, useState } from 'react'
import { Link } from 'react-router-dom'


type Props = {
    data:Array<any>, 
    mainTitle:string,
    toggle:any
}

function DropDown({mainTitle,data,toggle}: Props) {
    const [active,setActive]=useState(false)
    const toogle2 = useCallback(() => {
        setActive((prev) => !prev)
    }, [])
  return (
    <li   className="menu-item-has-children  ">
        <Link  to="/about">{mainTitle} </Link><span onClick={toogle2} className={active?"arrow active":"arrow"}><i className="flaticon-right-arrow"></i></span>
            <ul className="sub-menu" style={{display: active?'block':"none"}}>
                {data.map((item, index)=><React.Fragment key={`${item.subTitle}-${index}`}>
                <li onClick={()=>toggle()} className={item.miniLinks?"menu-item-has-children":""}><Link to={item.link}>{item.subTitle}</Link></li>{item.miniLinks?<span onClick={toogle2} className={active?"arrow active":"arrow"}><i className="flaticon-right-arrow"></i></span>: ""}
               {/* { item.miniLinks ?
                     <ul className="sub-menu">
                    {item.miniLink.map((links: Array<any>) => 
                    <li><a href="portfolio-grid.html.htm">Portfolio 3 Columns</a></li>
                    )}
                </ul>:""} */}
                
               
                </React.Fragment>)}

            </ul>
        </li>
  )
}

export default memo(DropDown)